export default __webpack_public_path__ + "641279f780e62aece0b7e1794b632ae7.svg";